const CurrencyFormatter = ({ value, currencyCode = true }) => {
  return (
    <span>
      {currencyCode !== false && (
        <>
          <span
            className="icon-saudi_riyal"
            style={{
              fontSize: "25px",
              fontWeight: "normal",
              verticalAlign: "middle",
              lineHeight: "0.1",
            }}
          ></span>
        </>
      )}
      {Number(value).toFixed(2)}
    </span>
  );
};

export default CurrencyFormatter;
